import { MutationOptions } from '@tanstack/react-query';
import { useApiMutation } from '~/hooks';
import { requestDataExportApi } from '../repository';

/**
 * Mutation hook for requesting data export
 * @param options - Additional mutation options
 * @returns React Query mutation result
 */
export const useRequestDataExportMutation = (
  options?: MutationOptions<void, CustomAxiosError, void>,
) => {
  return useApiMutation({
    ...options,
    mutationFn: () => requestDataExportApi(),
  });
};
